module.exports = __webpack_public_path__ + "img/sofa.be5030ca.webp";